import { render, staticRenderFns } from "./selected-criterion-taginput.vue?vue&type=template&id=f6017c8a&scoped=true&"
import script from "./selected-criterion-taginput.vue?vue&type=script&lang=js&"
export * from "./selected-criterion-taginput.vue?vue&type=script&lang=js&"
import style0 from "./selected-criterion-taginput.vue?vue&type=style&index=0&id=f6017c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6017c8a",
  null
  
)

export default component.exports